<template>
  <div class="fixed right-0 top-0 z-50 p-4 pointer-events-none pt-32">
    <transition-group name="toast">
      <div
        v-for="(toast, index) in toasts"
        :key="toast.id"
        class="toast text-sm p-3 shadow-lg rounded-lg transition-all duration-1000 pointer-events-auto"
        :class="getToastClasses(index, toast)"
      >
        <div class="flex items-start justify-between">
          <div :class="{ 'inline-flex items-start': toast.icon }">
            <span class="icon -mt-px p-1 text-base rounded-full" :class="[getIcon(toast), getIconClasses(toast)]" v-if="toast.icon" />
            <div class="ml-2 leading-tight">
              <p v-if="toast.title" class="font-bold mb-1">{{ toast.title }}</p>
              <div v-html=" toast.content" />
            </div>
          </div>
          <f3-button square rounded xsmall @click="remove(index)" :class="getButtonClasses(toast)">
            <span class="icon icon-close text-lg" />
          </f3-button>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import eventHub from "../helpers/event-hub";

export default {
  data() {
    return {
      toasts: []
    };
  },
  created() {
    eventHub.$on("toast:info", data => {
      this.info(data);
    });
    eventHub.$on("toast:success", data => {
      this.success(data);
    });
    eventHub.$on("toast:danger", data => {
      this.danger(data);
    });
    eventHub.$on("toast:warning", data => {
      this.warning(data);
    });
  },
  methods: {
    add(data) {
      const toast = { ...{ id: this.getId() }, ...data };
      this.toasts.push(toast);

      if (toast.autoleave) {
        setTimeout(() => {
          let index = 0;
          this.toasts.forEach((el, i) => {
            if (el === toast) {
              index = i;
            }
          });
          this.toasts.splice(index, 1);
        }, data.timeout || 6000);
      }
    },
    info(data) {
      this.add({ ...data, ...{ info: true } });
    },
    success(data) {
      this.add({ ...data, ...{ success: true } });
    },
    warning(data) {
      this.add({ ...data, ...{ warning: true } });
    },
    danger(data) {
      this.add({ ...data, ...{ error: true } });
    },
    remove(index) {
      this.toasts.splice(index, 1);
    },
    getId() {
      return (
        "_" +
        Math.random()
          .toString(36)
          .substr(2, 9)
      );
    },
    getToastClasses(index, toast) {
      return {
        "mt-2": index,
        "bg-white text-blue-900": toast.info,
        "bg-green-100 text-green-600": toast.success,
        "bg-red-100 text-red-600": toast.error,
        "bg-orange-100 text-orange-600": toast.warning
      };
    },
    getButtonClasses(toast) {
      return {
        "is-blue-100": toast.info,
        "is-green-100": toast.success,
        "is-red-100": toast.error,
        "is-orange-100": toast.warning
      };
    },
    getIconClasses(toast) {
      return {
        "bg-blue-200": toast.info,
        "bg-green-200": toast.success,
        "bg-red-200": toast.error,
        "bg-orange-200": toast.warning
      };
    },
    getIcon(toast) {
      return toast.icon ? `icon-${toast.icon}` : ''
    }
  }
};
</script>

<style scoped>
.toast {
  width: 300px;
  transition-timing-function: cubic-bezier(0.81, -0.35, 0.255, 1.37);
}
.toast-leave-active {
  @apply absolute;
}
.toast-enter,
.toast-leave-to {
  @apply transform opacity-0 translate-x-full;
}
</style>
